// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--crr-add-const-styl-main {
    width: 100%;
    height: auto;
    padding-top: 10px;
    padding-left: 130px;
    padding-right: 130px;
    padding-bottom: 50px;
    max-width: 1920px;
}

.scl--crr-add-const-styl-main h6 {
    padding: 0;
    margin: 0
}

.scl--crr-add-const-bread-sec-on {
    width: 100%;
    height: 21px;
    display: flex;
    gap: 5px;
}

/* Remove the broken rule entirely, replace with these */

.scl--crr-add-const-bread-sec-on button {
    color: rgba(138, 139, 143, 1);
    font-weight: normal;
    font-size: 12px;
    font-family: var(--font-family-inter);
    display: flex;
    align-items: center;
    position: relative;
    border: none;
    background: transparent;
    gap: 4px;
    margin-bottom: 3px;
    padding: 5px 1px;
    cursor: pointer; /* ✅ add this */
}

.scl--crr-add-const-bread-sec-on button:hover,
.scl--crr-add-const-bread-sec-on button:hover .scl--crr-add-const-bread-sec-on button .span-bread {
    color: #00000099 ;
    text-decoration: underline ;
    cursor: pointer ;
}
.scl--crr-add-const-bread-sec-on button:hover svg path{
    stroke: #000000;
}
.scl--crr-add-const-bread-sec-on button svg{
    display: flex;
    top: -4px;
}

.scl--crr-add-const-bread-sec-on span {
    color: rgba(138, 139, 143, 1);
    font-size: 14px;
    display: flex;
    align-items: center;
}

.scl--crr-add-const-bread-sec-on h6 {
    color: rgba(138, 139, 143, 1);
    font-weight: normal;
    font-size: 12px;
    font-family: var(--font-family-inter);
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 3px;
}

.scl--crr-add-const-bread-sec-on h6 .span-bread {
    position: absolute;
    left: 20px;
    font-family: var(--font-family-inter);
}

.scl--crr-add-const-bread-sec-on h6 svg {
    position: absolute;
    left: 2px;
}

.scl--crr-const-inp-sty-box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-top: 20px;
}

.scl--crr-const-inp-sty-box .grid-item {
    width: 100%;
    height: 38px;
}

.scl--crr-const-inp-sty-box .grid-item .scl--cms-components-selectField-wrapper,
.scl--crr-const-inp-sty-box .grid-item .scl--cms-components-selectField-container,
.scl--crr-const-inp-sty-box .grid-item .scl--cms-components-selectField-plate {
    height: 100%;
}

.scl--crr-deta-jb-add-sty-box {
    width: 100%;
    height: auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.scl--crr-dja-sty-box-item {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.scl--crr-dja-sty-box-item h6 {
    color: var(--typography-text-body-primary);
    font-size: 16px;
    font-weight: normal;
    font-family: var(--font-family-inter);
}

.scl--crr-dja-sty-box-item textarea {
    width: 100%;
    border-radius: 3px;
    outline: none;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.8);
    resize: none;
    background: transparent;
    box-sizing: border-box;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-family: var(--font-family-inter);
    font-size: 16px;
}

.scl--crr-dja-sty-box-item .text-area-fst-jb {
    min-height: 140px;
}

.scl--crr-dja-sty-box-item .text-area-ota {
    min-height: 63px;
}

.scl--crr-dja-sty-box-item .text-area-tta {
    min-height: 92px;
}

.scl--crr-btn-add-sty-box{
    width: 100%;
    display: flex;
    justify-content: end;
    gap: 12px;
    margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/career/css/hire-create.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,QAAQ;AACZ;;AAEA,wDAAwD;;AAExD;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAE,eAAe;AACpC;;AAEA;;IAEI,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,oCAAoC;IACpC,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,gBAAgB;AACpB","sourcesContent":[".scl--crr-add-const-styl-main {\n    width: 100%;\n    height: auto;\n    padding-top: 10px;\n    padding-left: 130px;\n    padding-right: 130px;\n    padding-bottom: 50px;\n    max-width: 1920px;\n}\n\n.scl--crr-add-const-styl-main h6 {\n    padding: 0;\n    margin: 0\n}\n\n.scl--crr-add-const-bread-sec-on {\n    width: 100%;\n    height: 21px;\n    display: flex;\n    gap: 5px;\n}\n\n/* Remove the broken rule entirely, replace with these */\n\n.scl--crr-add-const-bread-sec-on button {\n    color: rgba(138, 139, 143, 1);\n    font-weight: normal;\n    font-size: 12px;\n    font-family: var(--font-family-inter);\n    display: flex;\n    align-items: center;\n    position: relative;\n    border: none;\n    background: transparent;\n    gap: 4px;\n    margin-bottom: 3px;\n    padding: 5px 1px;\n    cursor: pointer; /* ✅ add this */\n}\n\n.scl--crr-add-const-bread-sec-on button:hover,\n.scl--crr-add-const-bread-sec-on button:hover .scl--crr-add-const-bread-sec-on button .span-bread {\n    color: #00000099 ;\n    text-decoration: underline ;\n    cursor: pointer ;\n}\n.scl--crr-add-const-bread-sec-on button:hover svg path{\n    stroke: #000000;\n}\n.scl--crr-add-const-bread-sec-on button svg{\n    display: flex;\n    top: -4px;\n}\n\n.scl--crr-add-const-bread-sec-on span {\n    color: rgba(138, 139, 143, 1);\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n\n.scl--crr-add-const-bread-sec-on h6 {\n    color: rgba(138, 139, 143, 1);\n    font-weight: normal;\n    font-size: 12px;\n    font-family: var(--font-family-inter);\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-bottom: 3px;\n}\n\n.scl--crr-add-const-bread-sec-on h6 .span-bread {\n    position: absolute;\n    left: 20px;\n    font-family: var(--font-family-inter);\n}\n\n.scl--crr-add-const-bread-sec-on h6 svg {\n    position: absolute;\n    left: 2px;\n}\n\n.scl--crr-const-inp-sty-box {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 15px;\n    margin-top: 20px;\n}\n\n.scl--crr-const-inp-sty-box .grid-item {\n    width: 100%;\n    height: 38px;\n}\n\n.scl--crr-const-inp-sty-box .grid-item .scl--cms-components-selectField-wrapper,\n.scl--crr-const-inp-sty-box .grid-item .scl--cms-components-selectField-container,\n.scl--crr-const-inp-sty-box .grid-item .scl--cms-components-selectField-plate {\n    height: 100%;\n}\n\n.scl--crr-deta-jb-add-sty-box {\n    width: 100%;\n    height: auto;\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n.scl--crr-dja-sty-box-item {\n    width: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.scl--crr-dja-sty-box-item h6 {\n    color: var(--typography-text-body-primary);\n    font-size: 16px;\n    font-weight: normal;\n    font-family: var(--font-family-inter);\n}\n\n.scl--crr-dja-sty-box-item textarea {\n    width: 100%;\n    border-radius: 3px;\n    outline: none;\n    padding: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    resize: none;\n    background: transparent;\n    box-sizing: border-box;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    font-family: var(--font-family-inter);\n    font-size: 16px;\n}\n\n.scl--crr-dja-sty-box-item .text-area-fst-jb {\n    min-height: 140px;\n}\n\n.scl--crr-dja-sty-box-item .text-area-ota {\n    min-height: 63px;\n}\n\n.scl--crr-dja-sty-box-item .text-area-tta {\n    min-height: 92px;\n}\n\n.scl--crr-btn-add-sty-box{\n    width: 100%;\n    display: flex;\n    justify-content: end;\n    gap: 12px;\n    margin-top: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
